import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import { useHistory } from 'react-router'
import { useUserContext } from '@hooks/useUserContext'
import CommonDropdown from '../components/common/CommonDropdown'
import CommonInput from '../components/common/CommonInput'
import CommonAvatar from '../components/common/CommonAvatar'
import CommonDivider from '../components/common/CommonDivider'
import CommonText from '../components/common/CommonText'
import PostTitle from '../components/post/PostTitle'
import CommonImage from '../components/common/CommonImage'
import IconText from '../components/post/IconText'
import { userApi, postApi } from '../api/api'

const MainPage = props => {
  const { state } = useUserContext()
  const history = useHistory()
  const [selected, setSelected] = useState('사용자')
  const [followings, setFollowings] = useState([])
  const [search, setSearch] = useState('')
  const [posts, setPosts] = useState(null)

  const getFollowing = async () => {
    if (!state.user) {
      return
    }

    const { following } = state.user
    const followerArr = []

    const asyncFollower = user => {
      return new Promise(resolve => {
        userApi.getUserInfo(user).then(({ resData }) => {
          followerArr.push(resData)
          resolve()
        })
      })
    }

    // eslint-disable-next-line array-callback-return
    const res = following?.map(user => {
      if (user.user) {
        return asyncFollower(user.user)
      }
    })
    await Promise.all(res)
    setFollowings(...followings, followerArr)
  }

  const goSearchResult = e => {
    if (e.key !== 'Enter') {
      return
    }

    const optionType = selected === '사용자' ? 'user' : 'posts'
    history.push(`/search/${optionType}/${search}`)
  }

  useEffect(() => {
    getFollowing()

    const Posts = async () => {
      try {
        const { resData } = await postApi.getChannelPostList(
          '6182ac24e1ecd063dabf102a',
        )
        setPosts(resData)
      } catch (e) {
        alert('포스트를 불러오는 도중 에러가 발생하였습니다!')
      }
    }
    Posts()
  }, [state])

  return (
    <>
      <MainPageStyle />
      <div className="margin-30">
        <div className="dropdown-input">
          <CommonDropdown
            onChange={e => setSelected(e.target.value)}
            name="search"
            options={[
              { text: '사용자', value: '사용자' },
              { text: '게시글', value: '게시글' },
            ]}
            value={selected}
          />
          <CommonInput
            width={480}
            isSearch
            placeholder="검색어를 입력하세요!"
            onChange={e => setSearch(e.target.value)}
            onKeyPress={goSearchResult}
          />
        </div>
        <div className="avatar-scroll">
          {followings?.map(userAvatar => (
            <div key={userAvatar._id} className="avatar-user">
              <CommonAvatar
                src={
                  userAvatar.image ||
                  require('../assets/images/404.png').default
                }
                width={60}
                height={100}
                username={userAvatar.fullName}
                fontSize={12}
                style={{ cursor: 'pointer' }}
                onClick={() => history.push(`/user/${userAvatar._id}`)}
              />
            </div>
          ))}
        </div>
      </div>
      <CommonDivider type="horizontal" />
      <div className="margin-30">
        {posts?.map(post => (
          <div
            key={post._id}
            className="margin-top"
            aria-hidden
            onClick={() => history.push(`/post/detail/${post._id}`)}>
            <CommonImage
              className="img-size"
              style={post.image ? null : { border: '1px solid #EAEBEC' }}
              src={
                post.image || require('../assets/images/404_wide.png').default
              }
            />
            <div className="flex">
              <PostTitle
                title={post.title}
                fullName={post.author.fullName}
                createdAt={post.createdAt}
              />
              <div className="icon-text">
                <IconText
                  iconText={[
                    {
                      id: 1,
                      icon: 'thumb',
                      text: post.likes.length,
                      color: '#FFA34B',
                    },
                    {
                      id: 2,
                      icon: 'comment',
                      text: post.comments.length,
                      color: '#FFA34B',
                    },
                  ]}
                />
              </div>
            </div>
            <CommonDivider type="horizontal" />
          </div>
        ))}
      </div>
    </>
  )
}

MainPage.propTypes = {}

const MainPageStyle = createGlobalStyle`
  .pointer {
    cursor: pointer;
  }
  .container{
    padding-left: 0;
    padding-right: 0;
  }
  header{
    padding: 0 30px;
  }
  .margin-30{
    padding: 0 30px;
  }
  .dropdown-input{
  display: flex;
  justify-content: space-between;
  margin: 50px 0px;
}
  .avatar-scroll{
    display: flex;
    overflow: hidden;
    overflow-x: scroll;
    -ms-overflow-style:none;
  }
  .avatar-scroll::-webkit-scrollbar{
    display:none;
  }
  .avatar-user{
    margin-right: 30px;
    transform-style: {opacity: 30%;};
  }
  .avatar-user:active{
    opacity: 30%;
  }
  .common-text{
    margin: 22px 0 0 500px;
  }
  .flex{
    display: flex;
    justify-content: space-between;
  }
  .icon-text{
    margin-top: 70px;
  }
  .margin-top{
    margin-top: 30px;
  }
  .img-size{
    width: 100%;
    height: 300px;
  }
`

export default MainPage
